export { VIPBadge } from './VIPBadge'
export type { VIPBadgeProps } from './VIPBadge'
